import { LazyAction, LazyModule } from 'owa-bundling';
import type { deleteFolder } from './deleteFolder';

export const lazyDeleteFolder: LazyAction<
    typeof deleteFolder,
    LazyModule<typeof import('./deleteFolder')>
> = new LazyAction(
    new LazyModule(() => import(/* webpackChunkName: "DeleteFolder"*/ './deleteFolder'), {
        name: 'DeleteFolder',
    }),
    m => m.deleteFolder
);
